import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { TimelineLayoutDTO } from '@tempo-io/roadmap-dto';
import { ONE_HOUR_IN_MS } from '@/lib/constants';
import { loopVisualizationQueryKeys } from '@/lib/query-keys/loop-visualizations';
import { headerToPropertySelector } from '@/lib/utils/loop-visualization/commonLayoutUtils';
import { getAndValidateTimelineLayout } from '@/lib/utils/loop-visualization/timelineLayout';

const getTimelineLayoutQueryOptions = (
  viewId: number,
  visualizationId: number,
  options?: Partial<UseQueryOptions<TimelineLayoutDTO, Error, TimelineLayoutDTO>>,
) =>
  queryOptions({
    queryKey: loopVisualizationQueryKeys.timelineLayout.detail(viewId, visualizationId),
    queryFn: () => getAndValidateTimelineLayout(viewId, visualizationId),
    retry: false,
    refetchOnMount: false,
    staleTime: ONE_HOUR_IN_MS,
    enabled: Boolean(viewId) && Boolean(visualizationId),
    ...options,
  });

export const useTimelineLayout = (
  viewId: number,
  visualizationId: number,
  options?: Partial<UseQueryOptions<TimelineLayoutDTO, Error, TimelineLayoutDTO>>,
) => {
  return useQuery(getTimelineLayoutQueryOptions(viewId, visualizationId, options));
};

export const useTimelineLayoutHeader = (viewId: number, visualizationId: number) => {
  return useQuery({
    ...getTimelineLayoutQueryOptions(viewId, visualizationId),
    select: (data) => ({
      header1: headerToPropertySelector(data.header1),
      header2: headerToPropertySelector(data.header2),
      itemLevelId: data.itemLevelId,
    }),
  });
};
